import React from "react";
import { Link } from "react-router-dom";

import aboutImg from "../assets/home-about.png";
import anandImg from "../assets/anand.png";

import PageHero from "../components/PageHero";
import {
  ArrowIcon,
  ClipboardIcon,
  HomeIcon,
  UsersIcon,
} from "../components/Icons";

const principles = [
  {
    icon: UsersIcon,
    title: "An efficient team",
    text: "The team is efficient and hands-on, so you deal with an adviser directly rather than a call centre. Between them they cover both lending and insurance, so one person can look at both rather than you dealing with two separate firms.",
  },
  {
    icon: HomeIcon,
    title: "Who we work with",
    text: "Our clients are mostly first home buyers, property investors and business owners. The job is much the same for all of them. We work out the real numbers and find a lender whose rules you fit, then talk you through the trade-offs before you sign.",
  },
  {
    icon: ClipboardIcon,
    title: "The unglamorous part",
    text: "A lot of this job is legwork: chasing the bank for documents and re-running the numbers when rates move. It’s all part of the service.",
  },
];

export default function AboutUsPage() {
  return (
    <div className="about-page">
      <PageHero
        kicker="About"
        title="About Expert Finance"
        subtitle="Mortgage and insurance advice from a hands-on Auckland team."
      />

      {/* Intro: what the business is, beside a photo */}
      <section className="about-section">
        <div className="about-intro">
          <div className="about-intro-text">
            <span className="about-eyebrow">Who we are</span>
            <p className="about-lead">
              Expert Finance advises on mortgages, insurance and business
              finance. That’s all we do.
            </p>
            <p className="about-body">
              We work across a range of banks, specialist lenders and insurers
              rather than for any one of them, so our advice isn’t tied to one
              lender’s products.
            </p>
            <p className="about-body">
              On the lending side, we work out what you can borrow, find the
              lenders likely to approve you, and set the loan up around your
              income and plans. That covers first homes, refinancing,
              investment property, building and business lending.
            </p>
            <p className="about-body">
              On the insurance side, we help you decide how much life, income,
              trauma and mortgage cover you need, then compare policies so you
              know what’s included, and what isn’t, before you sign.
            </p>
          </div>

          <div className="about-intro-media">
            <img src={aboutImg} alt="A family home" />
          </div>
        </div>
      </section>

      {/* How we work */}
      <section className="about-section">
        <div className="about-section-head">
          <span className="about-eyebrow">How we work</span>
          <h2 className="about-section-title">What to expect from us</h2>
        </div>

        <div className="about-principles">
          {principles.map(({ icon: PrincipleIcon, title, text }) => (
            <article key={title} className="about-principle">
              <span className="about-principle-icon">
                <PrincipleIcon size={22} />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Director */}
      <section className="about-section">
        <div className="about-director">
          <div className="about-director-photo">
            <img src={anandImg} alt="Anand Kumar" />
          </div>

          <div className="about-director-text">
            <span className="about-eyebrow about-eyebrow-light">Director</span>
            <h2>Anand Kumar</h2>
            <p>
              Anand holds a Master’s degree in Finance, Marketing, and
              Taxation, along with the New Zealand Certificate in Financial
              Services (Level 5), and he has spent most of his career on the
              lending side of the industry.
            </p>
            <Link to="/about/team" className="pill-btn pill-btn-ghost">
              Meet the whole team
              <ArrowIcon />
            </Link>
          </div>
        </div>
      </section>

      <section className="cta-band-section">
        <div className="cta-band">
          <div className="cta-band-text">
            <h2>Talk to us</h2>
            <p>
              One conversation is usually enough to know whether we can help.
            </p>
          </div>
          <div className="cta-band-actions">
            <Link to="/contact" className="pill-btn pill-btn-light">
              Contact us
              <ArrowIcon />
            </Link>
            <a href="tel:+6492176765" className="cta-band-phone">
              or call 09-2176765
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
